/**
 * @generated SignedSource<<968fc593e9d4ee20850d3dcdc1221f54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageType = "REACTION" | "SYSTEM" | "USER" | "%future added value";
export type CreateThreadCommentInput = {
  referenceId: string;
  text: UnknownJSON;
};
export type AnnouncementComments_chat_createCommentOnAnnouncementMutation$variables = {
  input: CreateThreadCommentInput;
};
export type AnnouncementComments_chat_createCommentOnAnnouncementMutation$data = {
  readonly createThreadComment: {
    readonly createdAt: ISO8601DateTimeString;
    readonly id: string;
    readonly isDelivered: boolean;
    readonly senderId: string | null;
    readonly text: UnknownJSON;
    readonly type: MessageType;
    readonly " $fragmentSpreads": FragmentRefs<"MessageReactions_chat_messageFragment">;
  };
};
export type AnnouncementComments_chat_createCommentOnAnnouncementMutation = {
  response: AnnouncementComments_chat_createCommentOnAnnouncementMutation$data;
  variables: AnnouncementComments_chat_createCommentOnAnnouncementMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDelivered",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnnouncementComments_chat_createCommentOnAnnouncementMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "createThreadComment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageReactions_chat_messageFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnnouncementComments_chat_createCommentOnAnnouncementMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "createThreadComment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReactionsConnection",
            "kind": "LinkedField",
            "name": "reactions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReactionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Message",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "938e1ed0df58a425f01235fa628e0cb5",
    "id": null,
    "metadata": {},
    "name": "AnnouncementComments_chat_createCommentOnAnnouncementMutation",
    "operationKind": "mutation",
    "text": "mutation AnnouncementComments_chat_createCommentOnAnnouncementMutation(\n  $input: CreateThreadCommentInput!\n) {\n  createThreadComment(input: $input) {\n    id\n    type\n    senderId\n    text\n    createdAt\n    isDelivered\n    ...MessageReactions_chat_messageFragment\n  }\n}\n\nfragment MessageReactions_chat_messageFragment on Message {\n  id\n  ...ReactionButton_chat_messageFragment\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n\nfragment ReactionButton_chat_messageFragment on Message {\n  id\n  reactions {\n    edges {\n      node {\n        id\n        text\n        senderId\n        deletedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1639be4bcd45ed12431de806ef534132";

export default node;
